<div id="investment-review-card">
    <div class="header d-flex flex-column flex-wrap">
        <div class="title col-12 col-sm-6 p-0">{{_investment.optionName}}</div>
        <div class="d-flex flex-row" *ngIf="_investment.percentage !== 100">
        <div class="percent" >{{_investment.percentage}}%</div>
        </div>
    </div>
    <div class="info d-flex flex-row flex-wrap">
        <div class="col-6 col-sm-4 col-md-3 p-0 label">Risk band</div>
        <div>{{_investment.optionRiskBand}}</div>
    </div>
    <div class="info d-flex flex-row flex-wrap">
        <div class="col-6 col-sm-4 col-md-3 p-0 label">Timeframe</div>
        <div>{{_investment.optionTimeframe}}</div>
    </div>
    <div class="info d-flex flex-row flex-wrap">
        <div class="col-6 col-sm-4 col-md-3 p-0 label">Fees and costs</div>
        <div>{{_investment.optionFees}}</div>
    </div>
</div>